import { ILanguage, ILocaleConfig, IPalette } from "../types";
import config from "./config.json";
import palette from "./palette.json";
import englishLang from "./languages/lang-en.json";

const developmentMode = process.env.NODE_ENV === "development";

let userConfig: ILocaleConfig = {
  numberFormat: "#,###.####",
  dateFormat: "MM-dd-yyyy",
  timeFormat: "HH:mm:ss",
  language: "en-us",
  useDefaultLocale: false
};

let currentLanguage: ILanguage = englishLang;

export const getConfiguration = (): any => {
  return config;
};

export const getPalette = (): IPalette => {
  return palette;
};

export const setDefaultLocaleConfig = (usrConfig: ILocaleConfig): void => {
  userConfig = usrConfig;
};

export const getDefaultLocaleConfig = (): ILocaleConfig => {
  return userConfig;
};

let colorIndex = 15;

export const getPaletteColor = (): string => {
  colorIndex = (colorIndex + 1) % 16;

  return palette.list[colorIndex];
};

export const updateCurrentLanguage = (language: ILanguage): void => {
  currentLanguage = language;
};

export const getCurrentLanguage = (): ILanguage => {
  return currentLanguage;
};


export const isDevelopmentMode = (): boolean => developmentMode;

export const isKioskMode = (): boolean => {
  const urlParams = new URLSearchParams( window.location.search);

  return urlParams.get("kiosk") === "1" && urlParams.get("dashboardID") !== null;
};

export const getDashboardID = (): number | null => {
  const urlParams = new URLSearchParams( window.location.search);
  const dashboardID = urlParams.get("dashboardID");

  return dashboardID ? parseInt(dashboardID, 10) : null;
};


